<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
        <span class="search_span_width">
        	<span class="search_span_width_part1">分组：</span>
        	<Select v-model="search.group_id" clearable  style="width:130px">
        		   <Option :value='1'>默认</Option>
        		   <Option :value='2'>智慧零售</Option>
        	</Select>
        </span>
			<span class="search_span_width">
				<span class="search_span_width_part1">FIGURE_ID：</span>
	       		<Input v-model="search.figure_id" style="width: 130px" />
	       	</span>
			<span class="search_span_width">
				<span class="search_span_width_part1">音色名称：</span>
	       		<Input v-model="search.timbrename" style="width: 130px" />
	       	</span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getVoiceList()">搜索</Button>
      </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="voice_list"></Table>
		  <Page :total="recordTotal" :current="page" :page-size="20" :show-elevator="true" @on-change="getVoiceList"/>
        </Card>
      </Card>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		search : {
			figure_id:'',
			timbrename:'',
			group_id : '1'
		},
		page: 1,
		loading2: false,
		recordTotal:0,
		showmodal:false,
		voice_list:[],
	
		tableColumns:[
		{ title: 'ID', key: 'id', align: 'center',width:'80px' },
		{ title: 'timbrekey', key: 'timbrekey', align: 'center',width:'220px' },
		{ title: '音色名称', key: 'timbrename', align: 'center' },
		{ title: '过期时间', key: 'expired_time', align: 'center' },
		{ title: 'figure_id', key: 'figure_id', align: 'center' },
		{ title: '创建时间', key: 'created_at', align: 'center' },
		{ title: 'demo', key: 'sample',
			render:(h,params) =>{
			   return h('span',{
				 domProps: {
				    innerHTML: '<audio controls="controls" style="width:100px;height:25px;"><source src="'+params.row.sample+'" type="audio/mpeg" /></audio>'
				}
			   })
			}
		 },
		]
	}
  },
  mounted:function(){
    this.getVoiceList();
  },
  computed:{

  },
  methods:{
	getVoiceList(page=this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http1.get('/voice/voice-list',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.voice_list = data.res.list;
			this.recordTotal = data.res.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	}
  }

}
</script>
